module.exports = __webpack_public_path__ + "static/media/7a4accfd-087c-4552-a16f-a3eba295def8.a76bf212.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/1274145/7a4accfd-087c-4552-a16f-a3eba295def8.ttf
// module id = 1664
// module chunks = 2